export const validateSafety = (formData) => {

    const {safety} = formData
    const errors = [];
  
    if (!safety) {
      errors.push({
        error: "Safety features field is required",
        errorType: 'safety'
      })
      return { errors, isValid: false };
    }
  
  
    if (safety.length === 0) {
      errors.push({
        error: "No safety feature selected. Consider adding at least one safety feature",
        errorType: 'safety'
      })
      return { errors, isValid: false };
    }
  
    return {
      errors,
      isValid: Object.keys(errors).length === 0,
    };
  };